import React from "react";
import { Helmet } from "react-helmet-async";
import Features from "../../components/widgets/features/Features";
import Hero from "../../components/widgets/Hero/Hero";
import "./Home.scss";

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ARYN Lyrics (Арін Лірікс) — Цифровий пісенник для церков і команд прославлення</title>
      </Helmet>
      <Hero />
      <Features />
    </div>
  );
};

export default Home;